    $(window).load(function(){ 
        var height=$('.m-philosophy .content-2 .m-content-introdute .m-img-large img').height() -60;
        $('.m-philosophy .content-2 .m-content-introdute .m-img-large .anm').css('height', height + 'px');
     
        var height=$('.m-philosophy .content-3 .m-content-introdute .m-img-large img').height() -60;
        $('.m-philosophy .content-3 .m-content-introdute .m-img-large .anm').css('height', height + 'px');

        var height=$('.m-philosophy .content-3 .m-content-image .m-img-large img').height() -60;
        $('.m-philosophy .content-3 .m-content-image .m-img-large .anm').css('height', height + 'px');
      
        var height=$('.content-5 .m-philosophy-box .m-content-introdute .m-img-large img').height() -60;
        $('.content-5 .m-philosophy-box .m-content-introdute .m-img-large .anm').css('height', height + 'px');

        var height=$('.m-philosophy__content .m-philosophy-box .m-content-image .m-img-large img').height() -60;
        $('.m-philosophy__content .m-philosophy-box .m-content-image .m-img-large .anm').css('height', height + 'px');
      
        var height=$('.m-philosophy .content-3 .m-content-image .m-img-large img').height() -60;
        $('.m-philosophy .content-3 .m-content-image .m-img-large .anm').css('height', height + 'px');

        var height=$('.m-philosophy-box .m-content-introdute .m-img-small img').height() -60;
        $('.m-philosophy-box .m-content-introdute .m-img-small .anm').css('height', height + 'px');

        var height=$('.m-philosophy__content .m-philosophy-box .m-content-image .m-img-small img').height() -60;
        $('.m-philosophy__content .m-philosophy-box .m-content-image .m-img-small .anm').css('height', height + 'px');

        var height=$('.m-philosophy .content-2 .m-content-image .m-img-large .anm img').height() -60;
        $('.m-philosophy .content-2 .m-content-image .m-img-large .anm').css('height', height + 'px');

        var height=$('.m-philosophy .content-2 .m-content-image .m-img-small .anm img').height() -60;
        $('.m-philosophy .content-2 .m-content-image .m-img-small .anm').css('height', height + 'px');

        var height=$('.m-philosophy .content-2 .m-content-introdute .m-img-small .anm img').height() -60;
        $('.m-philosophy .content-2 .m-content-introdute .m-img-small .anm').css('height', height + 'px');
      
        var height=$('.m-philosophy__content.content-3 .m-philosophy-box .m-content-image .m-img-small img').height() -60;
        $('.m-philosophy__content.content-3 .m-philosophy-box .m-content-image .m-img-small .anm').css('height', height + 'px');
              

        var height=$('.m-philosophy .content-5 .m-content-image .m-img-small img').height() -60;
        $('.m-philosophy .content-5 .m-content-image .m-img-small .anm').css('height', height + 'px');

      
        var height=$('.m-philosophy .content-3 .m-content-product .m-content-product__card .m-item img').height() -60;
        $('.m-philosophy .content-3 .m-content-product .m-content-product__card .m-item .anm').css('height', height + 'px');   
      
        var height=$('.m-philosophy__content .m-philosophy-box .m-content-product__card .m-item img').height() -60;
        $('.m-philosophy__content .m-philosophy-box .m-content-product__card .m-item .anm').css('height', height + 'px'); 

        var height=$('.m-philosophy .content-3 .m-content-product .m-content-product__card .m-item img').height() -60;
        $('.m-philosophy .content-3 .m-content-product .m-content-product__card .m-item .anm').css('height', height + 'px');
      
        var height=$('.m-philosophy .content-2 .m-content-product__card .m-item .anm img').height() -60;
        $('.m-philosophy .content-2 .m-content-product__card .m-item .anm').css('height', height + 'px');

        var height4m=$('.m-philosophy .content-4 .m-content-image .m-content-product__card .m-item .anm img').height() -60;
        $('.m-philosophy .content-4 .m-content-image .m-content-product__card .m-item .anm').css('height', height4m + 'px');

        var heightone=$('.m-philosophy__content .m-philosophy-box .m-content-image .m-img-large .anm.one img').height() -60;
        $('.m-philosophy__content .m-philosophy-box .m-content-image .m-img-large .anm.one').css('height', heightone + 'px');

        var heightoneb=$('.m-philosophy__content .m-philosophy-box .m-content-image .m-img-large .anm.one + .anm img').height() -60;
        $('.m-philosophy__content .m-philosophy-box .m-content-image .m-img-large .anm.one + .anm').css('height', heightoneb + 'px');

        var height5 =$('.m-philosophy__content.content-5 .m-philosophy-box .m-content-product__card .m-item .anm img').height() -60;
        $('.m-philosophy__content.content-5 .m-philosophy-box .m-content-product__card .m-item .anm').css('height', height5 + 'px');

        var height52 =$('.m-philosophy .content-5 .m-content-image.m-content-image-2 .m-img-large > .anm img').height() -60;
        $('.m-philosophy .content-5 .m-content-image.m-content-image-2 .m-img-large > .anm').css('height', height52 + 'px');
      
    });
$(window).on('scroll load', function(){

var con = $('footer.m-footer').offset();
var conTop = con.top ;
  
    var ua = navigator.userAgent;
  
    if ((ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0) && ua.indexOf('Mobile') > 0) {
      // スマートフォン用の記述
   let scrollTop = $(window).scrollTop();
   let winH = $(window).height();
   let section_bar_pos = $('.anim').offset().top;
  // 公式
   let section_bar_now = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 40 - 80;
  let section_bar_now2 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 21 - 80;
  let section_bar_now3 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 15 - 60;
  let section_bar_now4 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 11 - 62;
  let section_bar_now5 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 7 - 70;
  let section_bar_now6 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 7 - 90;
  let section_bar_now7 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 7 - 100;
  let section_bar_now8 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 7 - 120;
  let section_bar_now9 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 7 - 140;
  let section_bar_now10 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 7 - 160;
  let section_bar_now11 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 7 - 180;
   $('.anim img').css('transform', 'translateY(' + section_bar_now + 'px)');
   $('.anim2 img').css('transform', 'translateY(' + section_bar_now2 + 'px)');
   $('.anim3 img').css('transform', 'translateY(' + section_bar_now3 + 'px)');
   $('.anim4 img').css('transform', 'translateY(' + section_bar_now4 + 'px)');
   $('.anim5 img').css('transform', 'translateY(' + section_bar_now5 + 'px)');
  $('.anim6 img').css('transform', 'translateY(' + section_bar_now6 + 'px)');
  $('.anim7 img').css('transform', 'translateY(' + section_bar_now7 + 'px)');
  $('.anim8 img').css('transform', 'translateY(' + section_bar_now8 + 'px)');
  $('.anim9 img').css('transform', 'translateY(' + section_bar_now9 + 'px)');
  $('.anim10 img').css('transform', 'translateY(' + section_bar_now10 + 'px)');
  $('.anim11 img').css('transform', 'translateY(' + section_bar_now11 + 'px)');

    } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
      // タブレット用の記述
   let scrollTop = $(window).scrollTop();
   let winH = $(window).height();
   let section_bar_pos = $('.anim').offset().top;
  // 公式
   let section_bar_now = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 40 - 50;
  let section_bar_now2 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 21 - 50;
  let section_bar_now3 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 15 - 30;
  let section_bar_now4 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 11 - 42;
  let section_bar_now5 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 7 - 50;
  let section_bar_now6 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 7 - 70;
  let section_bar_now7 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 7 - 80;
  let section_bar_now8 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 7 - 90;
  let section_bar_now9 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 7 - 110;
  let section_bar_now10 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 7 - 130;
  let section_bar_now11 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 7 - 150;
   $('.anim img').css('transform', 'translateY(' + section_bar_now + 'px)');
   $('.anim2 img').css('transform', 'translateY(' + section_bar_now2 + 'px)');
   $('.anim3 img').css('transform', 'translateY(' + section_bar_now3 + 'px)');
   $('.anim4 img').css('transform', 'translateY(' + section_bar_now4 + 'px)');
   $('.anim5 img').css('transform', 'translateY(' + section_bar_now5 + 'px)');
  $('.anim6 img').css('transform', 'translateY(' + section_bar_now6 + 'px)');
  $('.anim7 img').css('transform', 'translateY(' + section_bar_now7 + 'px)');
  $('.anim8 img').css('transform', 'translateY(' + section_bar_now8 + 'px)');
  $('.anim9 img').css('transform', 'translateY(' + section_bar_now9 + 'px)');
  $('.anim10 img').css('transform', 'translateY(' + section_bar_now10 + 'px)');
  $('.anim11 img').css('transform', 'translateY(' + section_bar_now11 + 'px)');

    } else {
      // PC用の記述
   let scrollTop = $(window).scrollTop();
   let winH = $(window).height();
   let section_bar_pos = $('.anim').offset().top;
  // 公式
   let section_bar_now = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 40 - 50;
  let section_bar_now2 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 21 - 50;
  let section_bar_now3 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 15 - 30;
  let section_bar_now4 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 11 - 42;
  let section_bar_now5 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 7 - 50;
  let section_bar_now6 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 7 - 70;
  let section_bar_now7 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 7 - 80;
  let section_bar_now8 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 7 - 90;
  let section_bar_now9 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 7 - 110;
  let section_bar_now10 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 7 - 130;
  let section_bar_now11 = (1 - (section_bar_pos - scrollTop) / winH) * 1 * 7 - 150;
   $('.anim img').css('transform', 'translateY(' + section_bar_now + 'px)');
   $('.anim2 img').css('transform', 'translateY(' + section_bar_now2 + 'px)');
   $('.anim3 img').css('transform', 'translateY(' + section_bar_now3 + 'px)');
   $('.anim4 img').css('transform', 'translateY(' + section_bar_now4 + 'px)');
   $('.anim5 img').css('transform', 'translateY(' + section_bar_now5 + 'px)');
  $('.anim6 img').css('transform', 'translateY(' + section_bar_now6 + 'px)');
  $('.anim7 img').css('transform', 'translateY(' + section_bar_now7 + 'px)');
  $('.anim8 img').css('transform', 'translateY(' + section_bar_now8 + 'px)');
  $('.anim9 img').css('transform', 'translateY(' + section_bar_now9 + 'px)');
  $('.anim10 img').css('transform', 'translateY(' + section_bar_now10 + 'px)');
  $('.anim11 img').css('transform', 'translateY(' + section_bar_now11 + 'px)');

    }
});    